// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"df868917","453":"79f9157b","732":"99156788"}[chunkId] + ".chunk.js";
};